module.exports = __webpack_public_path__ + "img/60m3.c253ac97.jpg";